import { render, staticRenderFns } from "./ActionsBarComponent.vue?vue&type=template&id=f12bfdc4&scoped=true&lang=pug"
import script from "./ActionsBarComponent.vue?vue&type=script&lang=ts"
export * from "./ActionsBarComponent.vue?vue&type=script&lang=ts"
import style0 from "./ActionsBarComponent.vue?vue&type=style&index=0&id=f12bfdc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12bfdc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12bfdc4')) {
      api.createRecord('f12bfdc4', component.options)
    } else {
      api.reload('f12bfdc4', component.options)
    }
    module.hot.accept("./ActionsBarComponent.vue?vue&type=template&id=f12bfdc4&scoped=true&lang=pug", function () {
      api.rerender('f12bfdc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActionsBar/ActionsBarComponent.vue"
export default component.exports